<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 8.6L6 14.6L7.4 16L12 11.4L16.6 16L18 14.6L12 8.6Z" fill="#282828"/>
</svg>
